import React from 'react';

import { AssetTypes } from 'js/src/client';
import FileInputUI from 'js/src/components/app/upload-modal/FileInputUI';
import Callout from 'js/src/components/common/ui/Callout';

const ACCEPTED_AUDIO_MIME_TYPES = 'audio/mpeg,audio/wav,audio/x-m4a';

type VoiceCloningUploadStepProps = {
    onFilesSelected: (files: File[]) => void;
};

const VoiceCloningUploadStep: React.FC<VoiceCloningUploadStepProps> = ({ onFilesSelected }) => {
    return (
        <>
            <Callout
                text={
                    <>
                        For best result, upload a recording that's at least 1-2 minutes of clear
                        audio without any reverb, artifacts, or background noise of any kind.{' '}
                        <a
                            href="https://help.lumen5.com/en/article/best-practices-to-clone-your-voice-7mdmou/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Click here
                        </a>{' '}
                        to learn more best practices to clone your voice.
                    </>
                }
            />
            <FileInputUI
                filesSelected={onFilesSelected}
                acceptAssetTypes={[AssetTypes.AUDIO]}
                acceptMimeTypes={ACCEPTED_AUDIO_MIME_TYPES}
                disableMultipleFileUpload
                data-testid="voice-cloning-file-input"
            />
        </>
    );
};

export default VoiceCloningUploadStep;
